import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Input } from "../../../ui/Input/Input";
import { MagnifyingGlassIcon } from "../../../ui/icons/MagnifyingGlassIcon";
import { useCriteria } from "../../Accessories/Filters/Criteria/useCriteria";
import { BackToStore } from "../../BackToStore/BackToStore";

export const DealerPackagesHeader: FunctionComponent = () => {
  const [criteria, setCriteria] = useCriteria();
  const { t } = useTranslation();
  return (
    <header
      className={clsx(
        "my-8 flex flex-col items-start gap-2",
        "md:flex-row md:items-center md:justify-between"
      )}
    >
      <BackToStore />
      <Input
        onChange={(event): void => {
          setCriteria(event.target.value.trim());
        }}
        after={<MagnifyingGlassIcon />}
        aria-label="searchCriteria"
        className="bg-paper w-full md:max-w-sm"
        defaultValue={criteria}
        name="criteria"
        placeholder={t("national.search")}
      />
    </header>
  );
};
